import { render, staticRenderFns } from "./CopyInput.vue?vue&type=template&id=3ec96f78&"
import script from "./CopyInput.vue?vue&type=script&lang=ts&"
export * from "./CopyInput.vue?vue&type=script&lang=ts&"
import style0 from "./CopyInput.vue?vue&type=style&index=0&id=3ec96f78&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports